/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/13/14
 * Time: 4:14 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/categories/categoriesGridView.tmpl");
    var CategoriesGridRowView = require("manager-views/categories/CategoriesGridRowView");
    var CategoriesGridRowViewNewCategory = require("manager-views/categories/CategoriesGridRowViewNewCategory");

    var CategoriesGridView = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        CategoriesGridView = Marionette.GridView.extend({
            template : template,
            itemView : CategoriesGridRowView,
            itemViewContainer : "tbody",
            selectedItem:null,
            className: "table-main ui-table",
            ui: {
                "table" : "table",
                "scrollableArea": ".table-wrap"
            },
            itemEventsDeprecated:{
                "itemview:itemClicked":"onRowItemSelect"
            },

            initialize : function (options) {
                this.vent = options.vent;
                this.reqres = options.reqres;
                this.itemViewOptions = {vent: this.vent, reqres: this.reqres, hasEditPrivileges:options.hasEditPrivileges};

                this.listenTo(this.vent, "categoriesTable:showOrderActions", this.toggleOrderActions);
                this.listenTo(this.vent, "categoriesTable:addNewCategoryView", this.addNewCategoryView);
                this.listenTo(this.vent, "categoriesTable:removeCategoryView", this.removeCategoryView);
                this.listenTo(this.vent, "categories:enableNavigation", this._enableNavigation);

                Marionette.bindEntityEvents(this, this, this.itemEventsDeprecated);
            },

            onCompositeCollectionRendered:function(){
                _.each(this.collection.getSelected(), function(selectedModel){
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        this.children.findByModel(selectedModel).selectRow(true);
                    }
                }, this);
                this._handleDeleteAction();
            },

            /**
             * When row item is selected, clear the current selection from the ui and select in the ui and in the collection
             * @param itemView
             * @param isChecked
             */
            onRowItemSelect: function(itemView, isChecked) {
                if (isChecked) {
                    this._clearCurrentSelectionUi(); // this is because only single select is allowed
                    itemView.selectRow(true);
                    this.collection.addToSelection(itemView.model,{exclusively:true}); //exclusively=true to make it single select
                }
                else {
                    itemView.selectRow(false);
                    this.collection.deselectModel(itemView.model);
                }
                this._handleDeleteAction();
            },

            _clearCurrentSelectionUi: function() {
                var selectedModel = this.collection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        this.children.findByModel(selectedModel).selectRow(false);
                    }
                }
            },

            _handleDeleteAction: function() {
                var selectedModel = this.collection.getSelectedModel();
                this.vent.trigger("categoryTableLayout:deleteCategoryEnabled", !_.isEmpty(selectedModel));
            },

            toggleOrderActions: function(enabled) {
                this.ui.table.toggleClass("hide-order-actions", !enabled);
            },

            /**
             * When user wants to add a new category, we add a "fake" row to the table, this "fake" is represented by the class CategoriesGridRowViewNewCategory.
             * And, by product request, we scroll to the bottom of the table so the user sees the additional row
             * @param newCategoryModel
             */
            addNewCategoryView: function(newCategoryModel) {
                this.addItemView(newCategoryModel, CategoriesGridRowViewNewCategory, this.collection.size());
                this.scrollTableToBottom();
            },

            scrollTableToBottom: function() {
                var scrollBottom = this.ui.scrollableArea.scrollTop() + this.ui.scrollableArea.height();
                this.ui.scrollableArea.scrollTop(scrollBottom);
            },

            removeCategoryView: function(categoryModel) {
                this.removeItemView(categoryModel);
            },

            _enableNavigation: function(enabled) {
                this.allowSorting(enabled);
            }

        });
    });
    return CategoriesGridView;
});

